module.exports = __webpack_public_path__ + "6838de293b5bd184683e2ed73f4a22bc.png";